import m from "./dialog-layout.vue2.js";
import { resolveComponent as p, withDirectives as c, openBlock as o, createBlock as b, Transition as u, withCtx as g, createElementVNode as a, normalizeClass as h, createElementBlock as i, createVNode as r, createCommentVNode as t, toDisplayString as y, renderSlot as n, vShow as f } from "vue";
import "./dialog-layout.vue3.js";
import k from "../../_virtual/_plugin-vue_export-helper.js";
const v = ["data-testid"], _ = ["aria-labelledby", "aria-describedby"], C = ["id"], O = {
  key: 0,
  class: "image-wrapper"
}, j = { key: 1 }, I = ["id"], $ = {
  key: 0,
  class: "image-wrapper"
}, w = { class: "footer" };
function B(e, d, N, D, H, S) {
  const s = p("sequiter-image");
  return c((o(), b(u, { name: e.transitionName }, {
    default: g(() => [
      a("div", {
        class: "backdrop",
        "data-testid": e.transitionName
      }, [
        a("div", {
          class: h([e.variant, "container"]),
          role: "dialog",
          "aria-labelledby": e.titleId,
          "aria-describedby": e.descriptionId
        }, [
          e.headerHasContent ? (o(), i("header", {
            key: 0,
            class: "header",
            id: e.titleId,
            role: "header"
          }, [
            e.imageHeader ? (o(), i("span", O, [
              r(s, { imageObj: e.imageHeader }, null, 8, ["imageObj"])
            ])) : t("", !0),
            e.title ? (o(), i("span", j, y(e.title), 1)) : t("", !0),
            a("button", {
              type: "button",
              class: "btn-close",
              onClick: d[0] || (d[0] = (...l) => e.close && e.close(...l)),
              "aria-label": "Close dialog"
            }, [
              r(s, { imageObj: e.closeIcon }, null, 8, ["imageObj"])
            ])
          ], 8, C)) : t("", !0),
          a("section", {
            class: "body",
            id: e.descriptionId
          }, [
            e.imageBody ? (o(), i("span", $, [
              r(s, { imageObj: e.imageBody }, null, 8, ["imageObj"])
            ])) : t("", !0),
            n(e.$slots, "default", {}, void 0, !0)
          ], 8, I),
          a("footer", w, [
            n(e.$slots, "footer", {}, void 0, !0)
          ])
        ], 10, _)
      ], 8, v)
    ]),
    _: 3
  }, 8, ["name"])), [
    [f, e.isOpen]
  ]);
}
const L = /* @__PURE__ */ k(m, [["render", B], ["__scopeId", "data-v-0e2e12e1"]]);
export {
  L as default
};
//# sourceMappingURL=dialog-layout.vue.js.map
